<template>
    <div id="content" class="sub">
        <div class="grid--con-sub">
            <template v-if="mode == 'list'">
                <div class="faq-search">
                    <div class="box-type05">
                        <input type="text" placeholder="무엇을 도와드릴까요?" v-model="searchTxt" @keyup.enter="searchFaqList()"/>
                    </div>
                    <button @click="searchFaqList()"><div class="img-com _bt-ic03"><span>FAQ 검색 버튼 아이콘</span></div></button>
                </div>
                <div class="tab-faq">
                    <ul class="tabmenu __grid--tab5"><!-- 탭 수 클래스 수정 __grid--tab(N) -->
                        <li :class="selClcd == cdInfo.cd? 'current':''" v-for="(cdInfo, index) in clcdList"
                            :key="'cdInfo_'+index" @click="moveClcdInfo(cdInfo)">
                            <a href="javascript:;">{{cdInfo.cdNm}}</a>
                        </li>
                    </ul>
                    <div class="tab-container">
                        <div class="tab-content" id="tab-1" style="display:;">
                            <div class="board-number-cases mgt10" v-html="list.listCntMsg"></div>
                            <div class="board-list mgt10">
                                <ul v-if="list.faqList.length > 0">
                                    <li v-for="(faqInfo, index) in list.faqList" :key="'faqInfo_'+index" @click="showFaqView(faqInfo)">
                                        <a href="javascript:;">
                                            <div class="board-tit-con">
                                                <div class="entry-title" v-html="faqInfo.qestn"></div>
                                            </div>
                                        </a>
                                    </li>
                                </ul>
                                <ul v-if="list.faqList.length==0">
                                    <li>
                                        <a href="javascript:;">
                                            <div class="board-tit-con">
                                                <div class="entry-title">조회된 내역이 없습니다.</div>
                                            </div>
                                        </a>
                                    </li>
                                </ul>
                            </div>
                            <pagenavi :paginginfo="paginginfo" v-if="paginginfo.totCnt > paginginfo.pageListCnt"></pagenavi>
                        </div>
                    </div>
                </div>
            </template>

            <template v-if="mode == 'view'">
                <div class="board-view box-type04">
                    <div class="section-title">
                        <div class="board-tit-con">
                            <div class="entry-title" v-html="view.faqInfo.qestn"></div>
                        </div>
                    </div>
                    <div class="board-view-con" v-html="view.faqInfo.answer"></div>
                </div>
                <div class="btn-wrap __right mgt30">
                    <button class="middle _bt-ypurple" @click="showFaqList()"><span>목록으로</span></button>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
    const mixinView = {
        data : function(){
            return {
                view : {
                    faqInfo : new Array(),
                },
            }
        },
        methods : {
            showFaqList : function(){
                this.mode = 'list';
                this.searchTxt = '';
                this.searchFaqList();
            }
        }
    }

    const mixinList = {
        data : function(){
            return {
                list : {
                    faqList : new Array(),
                    listCntMsg : '',
                },
                paginginfo: {
                    totCnt: 0, /* 총게시물 수*/
                    pageListCnt: 15, /* 페이지당 게시물수 */
                    pageCnt: 10, /* 페이지당 게시물수 */
                    curPageNum: 1,/* 현재페이지 */
                    callBackFunc:null
                },
            }
        },
        computed: {
          loginAt : function(){
            return this.$store.getters.getLoginAt;
          },
        },
        methods : {
            showFaqView : function(faqInfo){
                if(!this.loginAt){
                  alert('로그인이 필요합니다.');
                  return;
                }

                if(faqInfo.qestn.indexOf('<span class="bg01">') != -1){
                    faqInfo.qestn = faqInfo.qestn.replace('<span class="bg01">'+this.searchTxt+'</span>', this.searchTxt);
                }

                this.view.faqInfo = JSON.parse(JSON.stringify(faqInfo));
                this.mode = 'view';
            }
        }
    }

    export default {
        name : 'faq',
        mixins : [mixinList, mixinView],
        data : function(){
            return {
                mode : '',
                srvcCd : 'SBIW02',
                clcdList : new Array(),
                selClcd : '',
                searchTxt : '',
            }
        },
        methods : {
            init : function(){
                this.paginginfo.callBackFunc = this.searchFaqList;
                this.mode = 'list';

                this.$nextTick(function(){
                    this.searchFaqList();
                })
            },
            searchFaqList : function(){
                const _this = this;
                this.axios.post('/i5gam/cs/faq/searchFaqList.act',{
                    pagingInfo : {
                        curPageNum : this.paginginfo.curPageNum,
                        startCnt : ((this.paginginfo.curPageNum-1) * this.paginginfo.pageListCnt)+1,
                        endCnt : this.paginginfo.curPageNum * this.paginginfo.pageListCnt,
                        clCd : this.selClcd,
                        searchTxt : this.searchTxt,
                        srvcCd : this.srvcCd
                    },
                }).then(function(response) {
                    const faqInfo = response.data.faqInfo;
                    this.list.faqList = faqInfo.faqList;
                    this.paginginfo.totCnt = faqInfo.pagingInfo.totCnt;
                    this.paginginfo.curPageNum = faqInfo.pagingInfo.curPageNum;
                    
                    const _this = this;
                    if(this.searchTxt == null || this.searchTxt == ''){
                        this.list.listCntMsg = '전체 <span>' + this.paginginfo.totCnt + '</span>건';
                    }else {
                        this.list.listCntMsg = '<span>' + this.searchTxt+'</span> 검색결과 <span>' + this.paginginfo.totCnt + '</span>건';
                        this.list.faqList.forEach(function(info){
                            info.qestn = info.qestn.replace(_this.searchTxt, '<span class="bg01">' + _this.searchTxt + '</span>');
                        });
                    }

                    window.scrollTo(0, 0);
                }.bind(this)).catch(function(e) {
                    console.log(e);
                    _this.$toasted.show(_this.$onbiLib.msg.err.system);
                    window.scrollTo(0, 0);
                });
            },
            moveClcdInfo : function(cdInfo){
                this.selClcd = cdInfo.cd;
                this.searchTxt = '';
                this.searchFaqList();
            },
        },
        mounted : function(){
            const _this = this;
            const searchInfo = {cdGrp : 'FAQ', filler1 : this.srvcCd};
            this.$onbiLib.searchCmmnCodeList(searchInfo).then(function(codeInfo){
                _this.clcdList = codeInfo;

                _this.clcdList.splice(0, 0, {cd : '', cdNm : '전체'});
                _this.selClcd = _this.clcdList[0].cd;
                _this.init();
            });
        }
    }
</script>